import { Grid, Paper } from "@material-ui/core";
import { FC, useState, useEffect } from "react";
import { useStyles } from "../styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { handleGetRabbitReports } from "../PerformanceCharts/requests";
import { RabbitReportsTable } from "../PerfomanceTables/RabbitReportsTable";
import { RabbitReportsChart } from "../PerformanceCharts/RabbitReportsChart";
import { PerformaceSeiralNumber } from "types/Performance";
import { ReturnedRabbitReportsChart } from "../PerformanceCharts/ReturnedRabbitReportsChart";

interface PropsType {
  station: string;
}

interface RequestData {
  result: PerformaceSeiralNumber[] | [];
  returned: {report__report_date: string, difference: number}[] | [];
}

const RabbitReportsContent: FC<PropsType> = ({ station }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [requestData, setRequestData] = useState<RequestData>({
    result: [],
    returned: [],
  });
  const { perfomanceSettings } = useTypeSelectors((state) => state.perfomanceScores);

  const { date, selectType } = perfomanceSettings;

  useEffect(() => {
    const params = {
      station,
      ...(selectType === "month" && { month: +date?.month, year: +date?.year }),
      ...(selectType === "week" && { week: +date?.week, year: +date?.year }),
      ...(selectType === "daily" && { day: date?.day }),
    };

    handleGetRabbitReports(params, setRequestData, setLoading);
  }, [station, date?.day, date?.year, date?.month, date?.week, selectType]);

  const filteredData = requestData?.result
    ?.sort((a: PerformaceSeiralNumber, b: PerformaceSeiralNumber) => b?.count - a?.count)
    ?.filter((item: PerformaceSeiralNumber) => item.serial_number !== null);

  return (
    <>
      <Grid className={classes.gridItem} item sm={12} lg={6} xl={12}>
        <Paper className={classes.graphPaper}>
          <RabbitReportsChart loading={loading} currentData={filteredData} />
        </Paper>
      </Grid>
      <Grid className={classes.gridItem} item sm={12} lg={6} xl={12}>
        <Paper className={classes.graphPaper}>
          <RabbitReportsTable loading={loading} currentData={filteredData} />
        </Paper>
      </Grid>
      <Grid className={classes.gridItem} item sm={12} lg={6} xl={12}>
        <Paper className={classes.graphPaper}>
          <ReturnedRabbitReportsChart loading={loading} currentData={requestData?.returned} />
        </Paper>
      </Grid>
    </>
  );
};

export default RabbitReportsContent;
